<div class="container-fluid col-12 col-xl-10 h-100">
    <div class="p-md-3">
        <div class="row row-cols-1 row-cols-md-3 mb-3">
            <div class="col my-1">

                <div class="border rounded-1 background-light p-3">
                    <!-- <h5 class="card-header">Localisation de la Station</h5> -->
                    <div class="row mb-3">
                        <h5 class="col text-center">Localisation de la Station</h5>
                    </div>

                    <!-- <div class="card-body h-100"> -->
                    <div class="row align-items-center">
                        <mat-form-field class="col">
                            <mat-label>X</mat-label>
                            <input matInput placeholder="X" type="number" [(ngModel)]="ModelGPS.L93X" (keyup)="onKeyUpEventForGPSX($event)"
                                   [formControl]="IsX2FarControl">
                            <mat-error *ngIf="IsX2FarControl.hasError('pattern')">
                                Format erroné. 6 chiffres uniquement !
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="col">
                            <mat-label>Y</mat-label>
                            <input matInput placeholder="Y" type="number" [(ngModel)]="ModelGPS.L93Y" (keyup)="onKeyUpEventForGPSY($event)"
                                   [formControl]="IsY2FarControl">
                            <mat-error *ngIf="IsY2FarControl.hasError('pattern')">
                                Format erroné. 7 chiffres uniquement !
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- <mat-divider class="my-2"></mat-divider> -->
                    <!-- </div> -->
                </div>
            </div>
            <div *ngIf="LacProcess.Is(ELacProcessTypes.PhysiqueChimieInSitu) || LacProcess.Is(ELacProcessTypes.PrelEauIntegre)" class="col-md-8 my-1">
                <div class="border rounded-1 background-light p-3">
                    <!-- <h5 class="card-header">Mesures Physico-chimiques In situ</h5> -->
                    <div class="row mb-3">
                        <h5 class="col text-center">Mesures Physico-chimiques In situ</h5>
                    </div>
                    <div class=" row">
                        <mat-form-field class="col-6">
                            <mat-label>Emplacement de la mesure</mat-label>
                            <mat-select placeholder="Emplacement de la mesure" [(ngModel)]="LacProcess.PhysiqueChimieInSitu.EmplacementMesure" required>
                                <mat-option *ngFor="let o of EmplacementMesureList; let i = index" [value]="i + 1">
                                    <span>{{o}}</span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="col-6" *ngIf="LacProcess.PhysiqueChimieInSitu.EmplacementMesure === EEmplacementMesure.BergePonton">
                            <mat-label>Distance berge</mat-label>
                            <input matInput placeholder="Distance berge" type="number" [(ngModel)]="LacProcess.PhysiqueChimieInSitu.DistanceBerge" [formControl]="DistanceBergeControl">
                        </mat-form-field>
                        <div *ngIf="LacProcess.PhysiqueChimieInSitu.EmplacementMesure !== EEmplacementMesure.BergePonton" class="col-6">

                        </div>

                        <!-- <mat-form-field class="col-6">
                            <input matInput placeholder="Secchi 1" type="number" [(ngModel)]="LacProcess.PhysiqueChimieInSitu.Secchi.Mesure1" [formControl]="Secchi1Control">
                        </mat-form-field>
                        <mat-form-field class="col-6">
                            <input matInput placeholder="Secchi 2" type="number" [(ngModel)]="LacProcess.PhysiqueChimieInSitu.Secchi.Mesure2" [formControl]="Secchi2Control">
                        </mat-form-field>
                        <mat-form-field class="col-6">
                            <input matInput placeholder="Secchi 3" type="number" [(ngModel)]="LacProcess.PhysiqueChimieInSitu.Secchi.Mesure3" [formControl]="Secchi3Control">
                        </mat-form-field> -->

                        <div class="row mt-3">
                            <h6 class="d-flex align-items-center m-0 col-auto">Mesures Secchi</h6>

                            <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="openMesureSecchi()">
                                <mat-icon>add</mat-icon>
                            </button>

                        </div>
                        <div class="row mt-3 justify-content-center">
                            <div *ngFor="let secchi of LacProcess.PhysiqueChimieInSitu.SecchiList; let i = index" class="col-auto">
                                <div class="border rounded-pill p-3 py-5 m-1">

                                    <div class="row justify-content-center">
                                        <div class="col-10">
                                            <mat-form-field class="w-100">
                                                <mat-label>Disparition (cm)</mat-label>
                                                <input matInput placeholder="Disparition (cm)" type="number" [(ngModel)]="secchi.Disparition" disabled="true">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row justify-content-center">
                                        <div class="col-10 ">
                                            <mat-form-field class="w-100">
                                                <mat-label>Réapparition (cm)</mat-label>
                                                <input matInput placeholder="Réapparition (cm)" type="number" [(ngModel)]="secchi.Reapparition" disabled="true">
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="p-0 d-flex justify-content-center">
                                        <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="openMesureSecchi(secchi)">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                        <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="removeSecchi(secchi)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">

                        <mat-form-field class="col-6">
                            <mat-label>Moyenne</mat-label>
                            <input matInput placeholder="Moyenne" (ngModelChange)="$event" [ngModel]="computeMoy() | number: '1.1-2'" readonly>
                        </mat-form-field>
                        <mat-form-field class="col-6">
                            <mat-label>Zeup</mat-label>
                            <input matInput placeholder="Zeup" (ngModelChange)="$event" [ngModel]="computeZeup() | number: '1.1-2'" readonly>
                        </mat-form-field>
                    </div>

                    <div class="row">

                        <mat-form-field class="col-6">
                            <mat-label>N° de boitier</mat-label>
                            <input matInput placeholder="N° de boitier" [(ngModel)]="LacProcess.PhysiqueChimieInSitu.Sonde.Appareil">
                        </mat-form-field>

                        <mat-form-field class="col-6">
                            <!-- <input matInput placeholder="N Sonde pH" [(ngModel)]="LacProcess.PhysiqueChimieInSitu.Sonde.SondePh"> -->
                            <mat-label>N° Sonde pH</mat-label>
                            <mat-select placeholder="N° Sonde pH" [(ngModel)]="LacProcess.PhysiqueChimieInSitu.Sonde.SondePh" (selectionChange)="registerSondePh($event)" required>
                                <mat-option *ngFor="let o of SondePhList;" [value]="o.Reference" [disabled]="!o.IsActive">
                                    <span>{{o.Reference}}</span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="row">

                        <mat-form-field class="col-6">
                            <!-- <input matInput placeholder="N Sonde Oxygène" [(ngModel)]="LacProcess.PhysiqueChimieInSitu.Sonde.SondeOxygene"> -->
                            <mat-label>N° Sonde Oxygène</mat-label>
                            <mat-select placeholder="N° Sonde Oxygène" [(ngModel)]="LacProcess.PhysiqueChimieInSitu.Sonde.SondeOxygene" (selectionChange)="registerSondeOxy($event)" required>
                                <mat-option *ngFor="let o of SondeOxygeneList; " [value]="o.Reference" [disabled]="!o.IsActive">
                                    <span>{{o.Reference}}</span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="col-6">
                            <!-- <input matInput placeholder="N Sonde Conductivité" [(ngModel)]="LacProcess.PhysiqueChimieInSitu.Sonde.SondeConductivite"> -->
                            <mat-label>N° Sonde Conductivité</mat-label>
                            <mat-select placeholder="N° Sonde Conductivité" [(ngModel)]="LacProcess.PhysiqueChimieInSitu.Sonde.SondeConductivite" (selectionChange)="registerSondeCond($event)"
                                        required>
                                <mat-option *ngFor="let o of SondeConductiviteList;" [value]="o.Reference" [disabled]="!o.IsActive">
                                    <span>{{o.Reference}}</span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="row my-3">
                        <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="LacProcess.PhysiqueChimieInSitu.CofracTemperatureEau.IsCofrac">Cofrac Temperature Eau</mat-slide-toggle>
                        <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="LacProcess.PhysiqueChimieInSitu.CofracPH.IsCofrac">Cofrac PH</mat-slide-toggle>
                        <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="LacProcess.PhysiqueChimieInSitu.CofracConductivite.IsCofrac">Cofrac Conductivite</mat-slide-toggle>
                        <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="LacProcess.PhysiqueChimieInSitu.CofracOxygeneDissous.IsCofrac">CofracOxygene Dissous</mat-slide-toggle>
                        <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="LacProcess.PhysiqueChimieInSitu.CofracSaturationO2d.IsCofrac">Cofrac Saturation O2d</mat-slide-toggle>
                    </div>

                    <div class="row justify-content-center my-2">
                        <button appPreventDoubleClick class="col-auto" mat-raised-button color="accent" (throttledClick)="addMesurePhysique()">
                            <mat-icon aria-label="add">add</mat-icon> Nouvelle mesure
                        </button>
                    </div>

                    <div class="row g-0">
                        <table mat-table #chimieTable [dataSource]="LacProcess.PhysiqueChimieInSitu.MesurePhysiqueList" multiTemplateDataRows class="mat-elevation-z8 w-100">

                            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                            <ng-container matColumnDef="expandedDetail">
                                <td mat-cell *matCellDef="let element; let i = dataIndex" [attr.colspan]="displayedColumns.length">
                                    <div class="example-element-detail row justify-content-center" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                                        <button class="col-auto" appPreventDoubleClick color="warn" mat-raised-button (throttledClick)="deleteMesure(i)">
                                            <mat-icon aria-label="save">delete</mat-icon> Supprimer
                                        </button>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="profondeur">
                                <th mat-header-cell *matHeaderCellDef class="col"> Prof (m) </th>
                                <td mat-cell *matCellDef="let element">
                                    <span *ngIf="element.IsForEauIntegre">
                                        Eau Intégré
                                    </span>
                                    <span *ngIf="!element.IsForEauIntegre">
                                        {{element.Profondeur}}
                                    </span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="o2">
                                <th mat-header-cell *matHeaderCellDef class="col"> O2 </th>
                                <td mat-cell *matCellDef="let element"> {{element.OxygeneDissous}} </td>
                            </ng-container>

                            <ng-container matColumnDef="sato2">
                                <th mat-header-cell *matHeaderCellDef class="col"> SatO2d </th>
                                <td mat-cell *matCellDef="let element"> {{element.SaturationO2d}} </td>
                            </ng-container>

                            <ng-container matColumnDef="pH">
                                <th mat-header-cell *matHeaderCellDef class="col"> pH </th>
                                <td mat-cell *matCellDef="let element"> {{element.pH}} </td>
                            </ng-container>

                            <ng-container matColumnDef="conduc">
                                <th mat-header-cell *matHeaderCellDef class="col"> Cond </th>
                                <td mat-cell *matCellDef="let element"> {{element.Conductivite}} </td>
                            </ng-container>

                            <ng-container matColumnDef="tempBrute">
                                <th mat-header-cell *matHeaderCellDef class="col"> Temp<br />Brute </th>
                                <td mat-cell *matCellDef="let element"> {{element.TemperatureBrute}} </td>
                            </ng-container>

                            <ng-container matColumnDef="tempCorrige">
                                <th mat-header-cell *matHeaderCellDef class="col"> Temp<br />Corrigée </th>
                                <td mat-cell *matCellDef="let element"> {{computeTemperatureFormula(element.TemperatureBrute) | number: '1.1-1'}} </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr tabindex="0" mat-row *matRowDef="let element; columns: displayedColumns;"
                                class="example-element-row"
                                [class.example-expanded-row]="expandedElement === element"
                                (click)="expandedElement = expandedElement === element ? null : element"
                                (focusout)="expandedElement = null">
                            </tr>
                            <tr tabindex="0" mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="example-detail-row"></tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="col my-1">
            <div class="border rounded-1 background-light p-3">
                <!-- <h5 class="card-header">Description de la station</h5> -->
                <div class="row mb-3">
                    <h5 class="col text-center">Description de la station</h5>
                </div>
                <div class="h-100">
                    <mat-form-field class="w-100">
                        <mat-label>Intensité vent</mat-label>
                        <mat-select placeholder="Intensité vent" [(ngModel)]="LacProcess.ConditionPrelevement.IntensiteVent" required>
                            <mat-option *ngFor="let iv of IntensiteVentList; let i = index" [value]="i">
                                <span>{{iv}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Surface d'eau</mat-label>
                        <mat-select placeholder="Surface d'eau" [(ngModel)]="LacProcess.ConditionPrelevement.SurfaceEau" required>
                            <mat-option *ngFor="let o of SurfaceEauList; let i = index" [value]="i + 1">
                                <span>{{o}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-100">
                        <mat-label>Condition Météo</mat-label>
                        <mat-select placeholder="Condition Météo" [(ngModel)]="LacProcess.ConditionPrelevement.Meteo" required>
                            <mat-option *ngFor="let o of MeteoList; let i = index" [value]="i + 1">
                                <span>{{o}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Bloom Algal</mat-label>
                        <mat-select placeholder="Bloom Algal" [(ngModel)]="LacProcess.ConditionPrelevement.BloomAlgal" required>
                            <mat-option *ngFor="let o of BloomAlgalList; let i = index" [value]="i + 1">
                                <span>{{o}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Présence marnage</mat-label>
                        <mat-select placeholder="Présence marnage" [(ngModel)]="LacProcess.ConditionPrelevement.PresenceMarnage" required>
                            <mat-option *ngFor="let o of PresenceMarnageList; let i = index" [value]="i + 1">
                                <span>{{o}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field *ngIf="LacProcess.ConditionPrelevement.PresenceMarnage === EPresenceMarnage.Oui" class="w-100">
                        <mat-label>Amplitude du marnage (m)</mat-label>
                        <input matInput placeholder="Amplitude du marnage (m)" type="number" [(ngModel)]="LacProcess.ConditionPrelevement.AmplitudeMarnage" [formControl]="AmplitudeMarnageControl">
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Hauteur des vagues (m)</mat-label>
                        <input matInput placeholder="Hauteur des vagues (m)" type="number" [(ngModel)]="LacProcess.ConditionPrelevement.HauteurVague" [formControl]="HauteurVagueControl">
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Profondeur max (m)</mat-label>
                        <input matInput placeholder="Profondeur max (m)" type="number" [(ngModel)]="LacProcess.ConditionPrelevement.Profondeur" [formControl]="ProfondeurControl">
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Cote NGF (m)</mat-label>
                        <input matInput placeholder="Cote NGF (m)" type="number" [(ngModel)]="LacProcess.ConditionPrelevement.CoteNGF">
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Cote Limnimétrique (m)</mat-label>
                        <input matInput placeholder="Cote Limnimétrique (m)" type="number" [(ngModel)]="LacProcess.ConditionPrelevement.CoteLimnimetrique">
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div *ngIf="LacProcess.Is(ELacProcessTypes.PrelEauPonctuel) && LacProcess.PrelEauPonctuelList && LacProcess.PrelEauPonctuelList.length > 0" class="col-md-8 my-1">
            <div class="border rounded-1 background-light p-3">
                <!-- <h5 class="card-header">Prélèvement d'eau ponctuels</h5> -->
                <div class="row mb-3">
                    <h5 class="col text-center">Prélèvement d'eau ponctuel</h5>
                </div>
                <div class="row">

                    <div class="col-12 col-md-6" *ngFor="let ponctuel of LacProcess.PrelEauPonctuelList">
                        <div class="row">
                            <div class="col">
                                <p><span class="fst-italic">SampleCode :</span> {{ponctuel.SampleCode}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p><span class="fst-italic">Profondeur :</span> {{ponctuel.Profondeur}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p><span class="fst-italic">Matériel :</span> {{getPonctuelMaterielName(ponctuel.Materiel)}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p><span class="fst-italic">Référence Matériel :</span> {{ponctuel.ReferenceMateriel}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p><span class="fst-italic">Température Glacière :</span> {{ponctuel.TemperatureGlaciere}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p><span class="fst-italic">Nb Flacons :</span> {{ponctuel.NbFlacon}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p><span class="fst-italic">Remarques :</span> {{ponctuel.Comment}}</p>
                            </div>
                        </div>
                        <div class="row p-1">
                            <button appPreventDoubleClick class="col" mat-raised-button color="primary" (throttledClick)="recordPonctuel(ponctuel)">
                                <mat-icon aria-label="save">edit</mat-icon> Saisir ponctuel
                            </button>
                            <mat-divider class="my-2"></mat-divider>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="LacProcess.Is(ELacProcessTypes.PrelEauIntegre)" class="col my-1">
            <div class="border rounded-1 background-light p-3">
                <!-- <h5 class="card-header">Prélèment d'eau intégré</h5> -->
                <div class="row mb-3">
                    <h5 class="col text-center">Prélèment d'eau intégré</h5>
                </div>
                <div class="card-body h-100">
                    <mat-form-field class="w-100">
                        <mat-label>Matériel</mat-label>
                        <mat-select placeholder="Matériel" [(ngModel)]="LacProcess.PrelEauIntegre.Materiel" required>
                            <mat-option *ngFor="let o of MaterielEauIntegrePhytoList; let i = index" [value]="i + 1">
                                <span>{{o}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-100">
                        <mat-label>Référence Matériel</mat-label>
                        <input matInput placeholder="Référence Matériel" [(ngModel)]="LacProcess.PrelEauIntegre.ReferenceMateriel">
                    </mat-form-field>

                    <mat-form-field class="w-100">
                        <mat-label>Profondeur min (m)</mat-label>
                        <input matInput placeholder="Profondeur min (m)" type="number" [(ngModel)]="LacProcess.PrelEauIntegre.PlageProfondeurDebut" [formControl]="PlageProfondeurDebutControl"
                               (keyup)="onMinAgainstMaxEAUintegre($event)">
                        <mat-error *ngIf="!PlageProfondeurDebutControl.valid">
                            Min doit etre inférieur a Max
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-100">
                        <mat-label>Profondeur max (m)</mat-label>
                        <input matInput placeholder="Profondeur max (m)" type="number" [(ngModel)]="LacProcess.PrelEauIntegre.PlageProfondeurFin" [formControl]="PlageProfondeurFinControl"
                               (keyup)="onMaxAgainstMinEAUintegre($event)">
                        <mat-error *ngIf="!PlageProfondeurFinControl.valid">
                            Min doit etre inférieur a Max
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-100">
                        <mat-label>Nombre de flacons</mat-label>
                        <input matInput placeholder="Nombre de flacons" type="number" [(ngModel)]="LacProcess.PrelEauIntegre.NbFlacon" [formControl]="NbFlaconControl">
                    </mat-form-field>

                    <mat-form-field class="w-100">
                        <mat-label>Température glacière</mat-label>
                        <input matInput placeholder="Température glacière" type="number" [(ngModel)]="LacProcess.PrelEauIntegre.TemperatureGlaciere" [formControl]="TemperatureGlaciereControl">
                    </mat-form-field>

                    <mat-form-field class="w-100">
                        <mat-label>Remarques, écart</mat-label>
                        <textarea matInput placeholder="Remarques, écart" [(ngModel)]="LacProcess.PrelEauIntegre.Comment"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div *ngIf="LacProcess.Is(ELacProcessTypes.PrelSediment)" class="col my-1">
            <div class="border rounded-1 background-light p-3">
                <!-- <h5 class="card-header">Prélèvement de sédiments</h5> -->
                <div class="row mb-3">
                    <h5 class="col text-center">Prélèvement de sédiments</h5>
                </div>
                <div class="card-body h-100">

                    <mat-form-field class="w-100">
                        <mat-label>Matériel</mat-label>
                        <mat-select placeholder="Matériel" [(ngModel)]="LacProcess.PrelSediment.Materiel" required>
                            <mat-option *ngFor="let m of MaterielSedimentList; let i = index" [value]="i + 1">
                                <span>{{m}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-100">
                        <mat-label>Référence Matériel</mat-label>
                        <input matInput placeholder="Référence Matériel" [(ngModel)]="LacProcess.PrelSediment.ReferenceMateriel">
                    </mat-form-field>

                    <mat-form-field class="w-100">
                        <mat-label>Profondeur (m)</mat-label>
                        <input matInput placeholder="Profondeur (m)" type="number" [(ngModel)]="LacProcess.PrelSediment.Profondeur"
                               [formControl]="SedimentPlageProfondeurControl">
                    </mat-form-field>
                    <span class="row align-items-center">
                        <mat-checkbox class="col-auto" [(ngModel)]="UnknownFat" (change)="knownEpaisseur()">Inconnu</mat-checkbox>
                        <mat-form-field class="col">
                            <mat-label>Epaisseur (cm)</mat-label>
                            <input class="" matInput placeholder="Epaisseur (cm)" type="number" [(ngModel)]="LacProcess.PrelSediment.Epaisseur" [formControl]="EpaisseurControl">
                        </mat-form-field>
                    </span>

                    <mat-checkbox class="mx-1" [(ngModel)]="LacProcess.PrelSediment.SupportSediment.Vases">Vases</mat-checkbox>
                    <mat-checkbox class="mx-1" [(ngModel)]="LacProcess.PrelSediment.SupportSediment.SedimentsFins">Sédiments Fins</mat-checkbox>
                    <mat-checkbox class="mx-1" [(ngModel)]="LacProcess.PrelSediment.SupportSediment.DebrisOrganiquesGrossiers">Débris Organiques Grossiers</mat-checkbox>
                    <mat-checkbox class="mx-1" [(ngModel)]="LacProcess.PrelSediment.SupportSediment.Sables">Sables</mat-checkbox>
                    <mat-checkbox class="mx-1" [(ngModel)]="LacProcess.PrelSediment.SupportSediment.Granulats">Granulats</mat-checkbox>
                    <mat-checkbox class="mx-1" [(ngModel)]="LacProcess.PrelSediment.SupportSediment.Pierres">Pierres</mat-checkbox>

                    <mat-form-field class="w-100">
                        <mat-label>Nombre de flacons</mat-label>
                        <input matInput placeholder="Nombre de flacons" type="number" [(ngModel)]="LacProcess.PrelSediment.NbFlacon" [formControl]="SedimentNbFlaconControl">
                    </mat-form-field>

                    <mat-form-field class="w-100">
                        <mat-label>Température glacière</mat-label>
                        <input matInput placeholder="Température glacière" type="number" [(ngModel)]="LacProcess.PrelSediment.TemperatureGlaciere"
                               [formControl]="SedimentTemperatureGlaciereControl">
                    </mat-form-field>

                    <mat-form-field class="w-100">
                        <mat-label>Remarques, écart</mat-label>
                        <textarea matInput placeholder="Remarques, écart" [(ngModel)]="LacProcess.PrelSediment.Comment"></textarea>
                    </mat-form-field>

                </div>
            </div>
        </div>
        <div *ngIf="LacProcess.Is(ELacProcessTypes.PrelPhyto)" class="col my-1">
            <div class="border rounded-1 background-light p-3">
                <!-- <h5 class="card-header">Prélèvement de phytoplancton</h5> -->
                <div class="row mb-3">
                    <h5 class="col text-center">Prélèvement de phytoplancton</h5>
                </div>
                <div class="card-body h-100">

                    <mat-form-field class="w-100">
                        <mat-label>Matériel</mat-label>
                        <mat-select placeholder="Matériel" [(ngModel)]="LacProcess.PrelPhyto.Materiel" required>
                            <mat-option *ngFor="let o of MaterielEauIntegrePhytoList; let i = index" [value]="i + 1">
                                <span>{{o}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-100">
                        <mat-label>Référence Matériel</mat-label>
                        <input matInput placeholder="Référence Matériel" [(ngModel)]="LacProcess.PrelPhyto.ReferenceMateriel">
                    </mat-form-field>

                    <mat-form-field class="w-100">
                        <mat-label>Volume final (mL)</mat-label>
                        <input matInput placeholder="Volume final (mL)" type="number" [(ngModel)]="LacProcess.PrelPhyto.VolumeFinal" [formControl]="VolumeFinalControl">
                    </mat-form-field>

                    <div class="row">
                        <button appPreventDoubleClick class="col" mat-raised-button color="primary" (throttledClick)="addEchantillonage()">
                            <mat-icon aria-label="save">add</mat-icon> Nouvel échantillonage
                        </button>
                    </div>
                    <div class="row">
                        <table mat-table #phytoTable [dataSource]="LacProcess.PrelPhyto.EchantillonnagePhytoList" class="mat-elevation-z8 w-100">
                            <ng-container matColumnDef="profondeur">
                                <th mat-header-cell *matHeaderCellDef class="col"> Prof (m) </th>
                                <td mat-cell *matCellDef="let element"> {{element.Profondeur}} </td>
                            </ng-container>

                            <ng-container matColumnDef="volume">
                                <th mat-header-cell *matHeaderCellDef class="col"> Volume </th>
                                <td mat-cell *matCellDef="let element"> {{element.Volume}} </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="phytoDisplayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: phytoDisplayedColumns;"></tr>
                        </table>
                    </div>

                    <mat-form-field class="w-100">
                        <mat-label>Volume Lugol Qualitatif (mL)</mat-label>
                        <input matInput placeholder="Volume Lugol Qualitatif (mL)" type="number" [(ngModel)]="LacProcess.PrelPhyto.VolumeLugolQualitatif"
                               [formControl]="VolumeLugolQualitatifControl">
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Code Filet</mat-label>
                        <input matInput placeholder="Code Filet" [(ngModel)]="LacProcess.PrelPhyto.CodeFilet">
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Plage Profondeur min (m)</mat-label>
                        <input matInput placeholder="Plage Profondeur min (m)" type="number" [(ngModel)]="LacProcess.PrelPhyto.PlageProfondeurDebut"
                               [formControl]="PhytoPlageProfondeurDebutControl" (keyup)="onMinAgainstMaxPhyto($event)">
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Plage Profondeur max (m)</mat-label>
                        <input matInput placeholder="Plage Profondeur max (m)" type="number" [(ngModel)]="LacProcess.PrelPhyto.PlageProfondeurFin" [formControl]="PhytoPlageProfondeurFinControl"
                               (keyup)="onMaxAgainstMinPhyto($event)">
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>Volume Lugol Quantitatif (mL)</mat-label>
                        <input matInput placeholder="Volume Lugol Quantitatif (mL)" type="number" [(ngModel)]="LacProcess.PrelPhyto.VolumeLugolQuantitatif"
                               [formControl]="VolumeLugolQuantitatifControl">
                    </mat-form-field>

                    <mat-form-field class="w-100">
                        <mat-label>Remarques, écart</mat-label>
                        <textarea matInput placeholder="Remarques, écart" [(ngModel)]="LacProcess.PrelPhyto.Comment"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="col-md-12 mt-3">
            <button appPreventDoubleClick class="col-12" mat-raised-button color="primary" (throttledClick)="update()">
                <mat-icon aria-label="save">save</mat-icon> Sauvegarder
            </button>
        </div>
    </div>
</div>